import Styled, {DefaultTheme} from 'styled-components';

type Props = {
    color: keyof DefaultTheme['colors'];
    cutout?: boolean;
};

/**
@note - the 1.67 line height is to counter the .9rem size but retain a 2rem height
I don't know the maths, I just kept changing the numbers till it was close.
*/
export default Styled.div.attrs((props: Props) => ({
    color: props.color || 'foreground',
    cutout: props.cutout
}))`${(p) => {
    const color = p.theme.colors[p.color];
    const lighterColor = p.theme.colors[`${p.color}900`];
    const darkerColor = p.theme.colors[`${p.color}300`];
    return `
        ${lighterColor ? `background-color: ${lighterColor}` : ''};
        color: ${darkerColor || color};
        border-radius: 3px;
        padding: .25rem 1rem;
        font-size: .9rem;
        font-weight: ${p.theme.fontWeights.regular};
        line-height: 1.67;
        ${p.cutout ? `border: 2px dashed ${color}; font-style: italic;` : ''}
    `;
}}`;
